import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'app-servicios',
  templateUrl: './servicios.component.html',
  styleUrls: ['./servicios.component.scss']
})
export class ServiciosComponent implements OnInit {

  constructor( private router: Router,
               private globals: Globals
  ) {

  }

  ngOnInit() {
    this.globals.app_title = "";
    this.irFinanciamiento();
  }

  irFinanciamiento() {
    this.globals.app_title = "WT001";
    this.router.navigate(["/iniciar-sesion"]);
  }

  irFraccionamiento() {
    this.globals.app_title = "WT002";
    this.router.navigate(["/iniciar-sesion"]);
  }

  irRecibosDigitales() {
    this.globals.app_title = "WT003";
    this.router.navigate(["/iniciar-sesion"]);
  }

}
